import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ClientAccount, HubspotIntegrationTypeEnum } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = { type: HubspotIntegrationTypeEnum };
type TData = Pick<ClientAccount, 'hubspotIntegration'>;

const MOCK: TVariables = {
  type: undefined as unknown as HubspotIntegrationTypeEnum
};

export const useHubSpotIntegration = (
  variables: TVariables,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query hubspotIntegration($type: HubspotIntegrationTypeEnum!) {
      clientAccount {
        hubspotIntegration(type: $type) {
          id
          selectedKeys
          applySelection
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useHubSpotIntegration', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: () =>
      client.request<unknown, TData>({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
